// extracted by mini-css-extract-plugin
export default {"box":"xU7wBCY8Vuh3RsPGVAgg","text":"mByI24AcEElF6AG5s5fe"};